module.exports = __webpack_public_path__ + "static/media/case-study-3.ed53adb7.pdf";